import pdfMake from 'pdfmake/build/pdfmake.js';
import moment from 'moment';

const ReportArdilaPdf = async (data) => {

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        },
        CantoraOne: {
            bold: 'CantoraOne-Regular.ttf'
        }
    };

    const fecha = moment(data.fecha + " " + data.hora).format('lll');

    const contentPDF = [{
        margin: [0, 150, 0, 10],
        columns: [
            {
                ul: [
                    { text: 'Historia Clinica No. ' + data.documentNumber, style: 'textStyle', listType: 'none' },
                    { text: data.names, bold: true, style: 'textStyle', listType: 'none' },
                    { text: 'No. Documento: ' + data.documentNumber, style: 'textStyle', listType: 'none' },
                    { text: 'Edad: ' + data.age, style: 'textStyle', listType: 'none' },
                    { text: 'Remitido Por: ' + data.remitente, style: 'textStyle', listType: 'none' }
                ]
            },
            {
                ul: [
                    { text: ' ', style: 'textStyle', listType: 'none' },
                    { text: 'Dirección: ' + data.address, style: 'textStyle', listType: 'none' },
                    { text: 'Telefono: ' + data.telephone, style: 'textStyle', listType: 'none' },
                    { text: 'Ocupacion: ' + data.ocupation, style: 'textStyle', listType: 'none' },
                    { text: 'Entidad: ' + data.plan, style: 'textStyle', listType: 'none' },
                ]
            },
        ],
        // optional space between columns
        columnGap: 10
    },
    {
        // auto-sized columns have their widths based on their content                                       
        margin: [0, 5, 0, 5],
        layout: {
            defaultBorder: false,
        },
        table: {
            headerRows: 1,
            widths: [90, '*', 200],
            heights: 20,
            body: [
                [{ text: 'Tipo de Atención ', style: 'textStyle', border: [false, true, false, false] },
                { text: 'Consulta', bold: true, style: 'textStyle', border: [false, true, false, false] },
                { text: 'Fecha: ' + fecha, style: 'textStyle', border: [false, true, false, false] }],
                [{ text: 'Firma Digital ', style: 'textStyle', border: [false, true, false, false] },
                { text: 'SANDRA ARDILA', bold: true, style: 'textStyle', border: [false, true, false, false] },
                { text: '', style: 'textStyle', border: [false, true, false, false] }],
            ]
        },
    }]

    if (data.motivo_consulta != undefined && data.motivo_consulta != null && data.motivo_consulta != "") {
        contentPDF.push({
            text: 'MOTIVO DE CONSULTA:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.motivo_consulta, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.descripcion != undefined && data.descripcion != null && data.descripcion != "") {
        contentPDF.push({
            text: 'DESCRIPCION:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.descripcion, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    
    if (data.interpretacion != undefined && data.interpretacion != null && data.interpretacion != "") {
        contentPDF.push({
            text: 'INTERPRETACION:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.interpretacion, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    if (data.recomendaciones != undefined && data.recomendaciones != null && data.recomendaciones != "") {
        contentPDF.push({
            text: 'RECOMENDACIONES:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.recomendaciones, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }   

    if (data.observaciones != undefined && data.observaciones != null && data.observaciones != "") {
        contentPDF.push({
            text: 'OBSERVACIONES:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
        },
        {
            text: data.observaciones, style: 'textStyle', margin: [0, 0, 0, 10]
        });
    }

    contentPDF.push({
        text: 'EVALUADOR:', style: 'textStyle', bold: true, margin: [0, 5, 0, 2]
    });

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: contentPDF,
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left',
                font: 'OpenSans'
            },

            textStyle: {
                fontSize: 9,
                font: 'OpenSans'
            },
            foter: {
                alignment: 'center',
                fontSize: 8,
                font: 'OpenSans'
            },
        }
    }

    pdfMake.createPdf(documentDefinition).open();

}

export default ReportArdilaPdf